import { __ } from '@wordpress/i18n';
import { useBlockProps, InspectorControls, InnerBlocks } from '@wordpress/block-editor';
import { PanelBody, SelectControl, Spinner, ToggleControl } from '@wordpress/components';
import { useEffect, useState } from '@wordpress/element';
import { useSelect } from '@wordpress/data';
import './editor.scss';

export default function Edit( { attributes, setAttributes } ) {
       const [ users, setUsers ] = useState( [] );
       const [ loading, setLoading ] = useState( true );

       useEffect( () => {
	       setLoading( true );
	       wp.apiFetch( { path: '/wp/v2/users?per_page=100' } )
		       .then( ( data ) => {
			       setUsers( data );
			       setLoading( false );
		       } )
		       .catch( () => setLoading( false ) );
       }, [] );

       return (
	       <>
		       <InspectorControls>
			       <PanelBody title={ __( 'Utilisateur', 'cineligue2025' ) } initialOpen={ true }>
				       { loading ? (
					       <Spinner />
				       ) : (
					       <SelectControl
						       label={ __( 'Sélectionner un utilisateur', 'cineligue2025' ) }
						       value={ attributes.userId || '' }
						       options={ [
							       { label: __( 'Aucun', 'cineligue2025' ), value: '' },
							       ...users.map( user => ( {
								       label: user.name + (user.email ? ` (${user.email})` : ''),
								       value: user.id
							       } ) )
						       ] }
						       onChange={ ( value ) => setAttributes( { userId: value } ) }
					       />
				       ) }
					   <ToggleControl
					       label={ __( 'Afficher le lien "En savoir plus"', 'cineligue2025' ) }
					       checked={ !!attributes.enSavoirPlus }
					       onChange={ ( value ) => setAttributes( { enSavoirPlus: value } ) }
				       />
			       </PanelBody>
		       </InspectorControls>
		       <div { ...useBlockProps() }>
			       <InnerBlocks/>
		       </div>
	       </>
       );
}
